export const workingDaysColorCodes = {
  active: "#336260",
  outage: "#FCA5A5",
  holiday: "#ADD8E6",
  inactive: "#991B1B",
  critical_disturbance: "#E7BC66",
} as Record<string, string>;

export const nonWorkingDaysTypes = ["public_holiday", "company_holiday", "disturbance"];
